import { useEffect, useContext, useState } from "react";
import Utils from "../../Utils";
import axios from "axios";
import { ReactSearchAutocomplete } from 'react-search-autocomplete';

import HrNotifications from "../../components/hotelRepresentative/HrNotifications";
import HrCertification from "../../components/hotelRepresentative/HrCertification";

const HrPhotoshootRequirementForm = (props) => {

    /* Getting List of Photographers */
  const [photographers, setPhotographers] = useState([]);
  /* Recce enabled state */
  const [recceEnabled, setRecceEnabled] = useState(false);
  /* Getting list of countries */
  useEffect(() => {
    axios
      .get(Utils.apiUrl("hr/photographers", 'limit=99999&fields=id,name'), Utils.apiHeaders())
      .then((res) => {
        if(res.data.success) {
          setPhotographers(res.data.data);
        }
      })
      .catch((err) => {
        //callback(false, err.message);
      });
  }, []);

  /* Scroll to top function on submit of form */
  const scrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: "smooth",
    });
  };

  /* Err list for validation of form */
  const [submitted, setSubmitted] = useState(false);
  const [succ, setSucc] = useState({status: false, message: ''});
  const [err, setErr] = useState([]);
  const [pgID, setPGID] = useState(0);

  /* Submitting Photoshoot Request  */
  const submitPhotoshootRequest = (e) => {
    scrollToTop();
    const frm = e.currentTarget;
    e.preventDefault();

    const formData = new FormData();
    //formData.append('title', frm.title.value);
    formData.append('date_from', frm.date_from.value);
    formData.append('date_to', frm.date_to.value);
    formData.append('lifestyle', frm.lifestyle.value);
    formData.append('architectural', frm.architectural.value);
    formData.append('hotel_type', frm.hotel_type.value);
    formData.append('recce_start', frm.recce_start.value);
    formData.append('recce_end', frm.recce_end.value);
    formData.append('notes', frm.notes.value);
    formData.append('photographer_id', pgID);
    formData.append('budget', frm.budget.value);
    // Add attachments
    const files = frm.attachments.files;
    for (let i = 0; i < files.length; i++) {
      formData.append('attachments', files[i]);
    }
    
    let err1 = [];
    //if(frm.title.value == '') {err1.push('Enter Photoshoot Title');}
    if(frm.date_from.value == '') {err1.push('Select Photoshoot Date (From)');}
    if(frm.date_to.value == '') {err1.push('Select Photoshoot Date (To)');}
    if(frm.lifestyle.value == '') {err1.push('Enter Number of Photos Needed (Lifestyle)');}
    if(frm.architectural.value == '') {err1.push('Enter Number of Photos Needed (Architectural)');}
    if(frm.hotel_type.value == '') {err1.push('Select Type of Hotel');}
    /* if(frm.notes.value == '') {err1.push('Enter Notes');} */
    if(pgID == 0) {err1.push('Select Photographer');}
    /* if(frm.budget.value == '') {err1.push('Enter Amount paid to photographer for photoshoot');} */
    setErr(err1);
    if(err1.length == 0) {
      axios
        .post(Utils.apiUrl(`hr/phrequest`), formData, Utils.apiHeaders())
        .then((res) => {
          if(res.data.success) {
            setSubmitted(true);
            /* setSucc({status: true, message: res.data.message});
            setTimeout(function() {
                window.location.reload();
            }, 2000); */
          }
          else {
            setSucc({status: false, message: ''});
            err1.push(res.data.message);
            setErr(err1);
          }
          //console.log(frmMess);
        })
        .catch((err) => {
          //callback(false, err.message);
        });
    }
    
  }

  const [guidelineDetails, setGuidelineDetails] = useState([]);
  const [hotelDetails, setHotelDetails] = useState([]);
  /* Getting HR Hotel Details */
  useEffect(() => {
    axios
        .get(Utils.apiUrl(`hr/brandDetail`), Utils.apiHeaders())
        .then((res) => {
          if(res.data.success) {
            /* Getting Hotel Details */
            axios
                .get(Utils.apiUrl(`brand/${res.data.brand.brand_id}`), Utils.apiHeaders())
                .then((res) => {
                    //console.log(res);
                    var udata = Utils.getUserData();
                    //console.log(udata.hotel_id);
                    if(res.status == 200) {
                        /* Getting Hotel Details */
                        axios
                            .get(Utils.apiUrl(`hotel/${udata.hotel_id}`), Utils.apiHeaders())
                            .then((res) => {
                                console.log(res);
                                if(res.status == 200) {
                                    setHotelDetails(res.data);
                                }
                            })
                            .catch((err) => {
                            //callback(false, err.message);
                            });
                        setGuidelineDetails(res.data);

                    }
                })
                .catch((err) => {
                //callback(false, err.message);
                });
          }
          //console.log(frmMess);
        })
        .catch((err) => {
          //callback(false, err.message);
        });
  }, []);


  return (
    <>
      <div className="container mx-auto p-8">
        <h2 className="text-2xl font-bold text-center mb-6">Photoshoot Requirement Form</h2>
        {/* When form is not submitted */}
        {submitted == false && (
            <>
            {/* For Success on submission */}
            {/* {succ.status == true && 
            <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-2 text-sm rounded relative mb-4
             w-full max-w-2xl mx-auto" role="alert">
                <p><strong>{succ.message}</strong></p>
            </div>
            } */}

            {/* For Error on submission */}
            {err.length > 0 && 
            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-2 text-sm rounded relative mb-4
             w-full max-w-2xl mx-auto" role="alert">
                <ul>
                {err.map((item, index) => (
                    <li key={index} className="block">{item}</li>
                ))}
                </ul>
            </div>
            }

            {/* When form is not submitted */}
            <>
            <form method="get" action="hotel-representative-photoshoot-requirement-form-confirmation.html" className="bg-white p-8 rounded-lg shadow-md w-full max-w-2xl mx-auto" onSubmit={submitPhotoshootRequest}>
                <h3 className="text-lg font-medium mb-4">{`${hotelDetails.marsha}_${guidelineDetails.abbr}_${hotelDetails.name}`}</h3>
                {/* <div className="mb-4">
                    <label for="title" className="block text-gray-700 text-sm font-bold mb-2">Photoshoot Title:</label>
                    <input type="text" id="title" name="title" className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" placeholder="Enter Photoshoot Title"
                        value={`${hotelDetails.marsha}_${guidelineDetails.abbr}_${hotelDetails.name}`} />
                </div> */}
                <div className="mb-4 flex space-x-4">
                    <div className="w-1/2">
                        <label for="date_from" className="block text-gray-700 text-sm font-bold mb-2">Photoshoot Date (From):</label>
                        <input type="date" id="date_from" name="date_from" className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" />
                    </div>
                    <div className="w-1/2">
                        <label for="date_to" className="block text-gray-700 text-sm font-bold mb-2">Photoshoot Date (To):</label>
                        <input type="date" id="date_to" name="date_to" className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" />
                    </div>
                </div>
                
                <div className="section-heading">
                    Number of Photos Needed
                </div>
                <div className="mb-4 flex space-x-4">
                    <div className="form-group w-1/2">
                        <label for="lifestyle" className="form-label">Lifestyle</label>
                        <input name="lifestyle" id="lifestyle" type="number" className="form-input" />
                    </div>
                    <div className="form-group w-1/2">
                        <label for="architectural" className="form-label">Architectural</label>
                        <input name="architectural" id="architectural" type="number" className="form-input" />
                    </div>
                </div>
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2">Type of Hotel:</label>
                    <div className="">
                        <label className="block items-center">
                            <input type="radio" name="hotel_type" id="hotel_type_new" value="new" className="form-radio" onChange={(e) => setRecceEnabled(true)} />
                            <span className="ml-2 mb-2 inline-block">Pre-opening/New Build <span className="recce-tag">Recce Recommended</span></span>
                        </label>
                        <label className="block items-center">
                            <input type="radio" name="hotel_type" id="hotel_type_converted" value="converted" className="form-radio" onChange={(e) => setRecceEnabled(true)} />
                            <span className="ml-2 mb-2 inline-block">Converted Property <span className="recce-tag">Recce Recommended</span></span>
                        </label>
                        <label className="block items-center">
                            <input type="radio" name="hotel_type" id="hotel_type_established" value="established" className="form-radio" onChange={(e) => setRecceEnabled(true)} />
                            <span className="ml-2 mb-2 inline-block">Established Property <span className="recce-tag">Recce Not Needed</span></span>
                        </label>
                    </div>
                </div>
                <div className="reccedetails">
                    <div className="mb-4 flex space-x-4">
                        <div className="w-1/2">
                            <label for="recce_start" className="block text-gray-700 text-sm font-bold mb-2">Recce Date (From):</label>
                            <input type="date" id="recce_start" name="recce_start" className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" disabled={!recceEnabled} />
                        </div>
                        <div className="w-1/2">
                            <label for="recce_end" className="block text-gray-700 text-sm font-bold mb-2">Recce Date (To):</label>
                            <input type="date" id="recce_end" name="recce_end" className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" disabled={!recceEnabled} />
                        </div>
                    </div>
                </div>
                <div className="mb-4">
                    <label for="notes" className="block text-gray-700 text-sm font-bold mb-2">Notes:</label>
                    <textarea name="notes" id="notes" className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"></textarea>
                </div>
                <div className="mb-4">
                    <label for="photographer_id" className="block text-gray-700 text-sm font-bold mb-2">Assign Photographer:</label>
                    <div className="chosenwrap">
                        <ReactSearchAutocomplete
                            items={photographers.map((photographer) => ({id: photographer.id, name: photographer.name}))}
                            onSelect={({id}) => setPGID(id)}
                            onClear={() => setPGID('')}
                            placeholder="Select Photographer"
                            fuseOptions={{ keys: ["name"] }}
                            resultStringKeyName="name"
                        />
                    </div>
                </div>
                <div className="mb-4">
                    <label for="attachments" className="block text-gray-700 text-sm font-bold mb-2">Attachments:</label>
                    <input type="file" id="attachments" name="attachments" className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" multiple="multiple" />
                </div>
                <div className="mb-6">
                    <label for="budget" className="block text-gray-700 text-sm font-bold mb-2">Amount paid to photographer for photoshoot:</label>
                    <input type="number" id="budget" name="budget" className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" placeholder="Enter overall budget of the photoshoot" />
                </div>
                <div className="flex items-center justify-center">
                    <button type="submit" className="btn text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full">
                        Submit
                    </button>
                </div>
            </form>
            </>
        </>
        )}

        {/* When form is submitted */}
        {submitted == true && (
            <>
            <div className="confirmation-message text-center">
                <p className="text-lg text-green-600 mb-4">Photoshoot request has been submitted successfully.</p>
            </div>
            <div className="block bg-white shadow-md rounded-lg p-6 mb-6">
                <h2 className="text-xl font-bold mb-4">Guideline for Hotel Photography Lead</h2>
                <div className="mb-6" dangerouslySetInnerHTML={{ __html: guidelineDetails.hr_guidelines }}>
                </div>

            </div>
            </>
        )}

        </div>
    </>
  );
};

export default HrPhotoshootRequirementForm;
